export default function InfoSection() {
  return (
    <section className="py-12 md:py-16 bg-[#161b22]">
      <div className="w-full px-4 md:px-8 max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-light text-gray-200 mb-8">
          Special Information for our clients on Hacker&apos;s list
        </h2>
        <h3 className="text-xl md:text-2xl font-semibold text-gray-200 mb-2">
          To avoid getting scammed
        </h3>
        <p className="text-sm text-gray-400 mb-6">
          Please check the Guidelines before you hire any hacker on hacker&apos;s list
        </p>
        <a
          href="https://hackerslodge.com/hacking-news/how-to-stay-protected-from-cryptocurrency-scam-and-fraud"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-[#5bc0de] hover:bg-[#46b8da] text-white text-sm font-semibold px-6 py-2 rounded transition-all whitespace-nowrap"
        >
          READ MORE
        </a>
      </div>
    </section>
  );
}